import { useEffect, useRef } from 'react';
import { registerKeyHandler, unregisterKeyHandler } from 't-lib-ui/structure';

/**
 * Esc navigates back while a page offers a way back (`onBack` set): a back arrow or a Home crumb.
 * The priority sits above the layout's Esc-toggles-sidebar handler but below cards (20) and
 * modals (1000+), which keep Esc first. Ignored while typing in a field.
 */
export const useEscapeBack = (name: string, onBack: (() => void) | undefined) => {
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;
  const active = !!onBack;
  useEffect(() => {
    if (!active) return;
    registerKeyHandler(name, {
      'Escape': () => {
        const ae = document.activeElement as HTMLElement | null;
        if (ae?.tagName == 'INPUT' || ae?.tagName == 'TEXTAREA' || ae?.isContentEditable || !onBackRef.current) return false;
        onBackRef.current();
        return true;
      },
    }, false, 10);
    return () => unregisterKeyHandler(name);
  }, [name, active]);
};
